function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M409.602 512H307.199C302.488 512 298.668 508.176 298.668 503.465V93.8672C298.668 89.1562 302.488 85.332 307.199 85.332H409.602C414.309 85.332 418.133 89.1562 418.133 93.8672V503.465C418.133 508.176 414.309 512 409.602 512V512ZM315.734 494.934H401.066V102.398H315.734V494.934Z",
  fill: "#b76401"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M469.332 512H409.602C404.891 512 401.066 508.176 401.066 503.465V256C401.066 251.289 404.891 247.465 409.602 247.465H469.332C474.043 247.465 477.867 251.289 477.867 256V503.465C477.867 508.176 474.043 512 469.332 512V512ZM418.133 494.934H460.801V264.535H418.133V494.934Z",
  fill: "#b76401"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M307.199 426.668H238.934C234.223 426.668 230.398 422.844 230.398 418.133V221.867C230.398 217.156 234.223 213.332 238.934 213.332H307.199C311.91 213.332 315.734 217.156 315.734 221.867V418.133C315.734 422.844 311.91 426.668 307.199 426.668V426.668ZM247.465 409.602H298.668V230.398H247.465V409.602Z",
  fill: "#b76401"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M170.668 512H51.1992C46.4883 512 42.668 508.176 42.668 503.465V162.133C42.668 157.422 46.4883 153.602 51.1992 153.602H170.668C175.379 153.602 179.199 157.422 179.199 162.133V503.465C179.199 508.176 175.379 512 170.668 512ZM59.7344 494.934H162.133V170.668H59.7344V494.934Z",
  fill: "#b76401"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M153.602 170.668H68.2656C63.5547 170.668 59.7344 166.844 59.7344 162.133V110.934C59.7344 106.223 63.5547 102.398 68.2656 102.398H153.602C158.309 102.398 162.133 106.223 162.133 110.934V162.133C162.133 166.844 158.309 170.668 153.602 170.668ZM76.8008 153.602H145.066V119.465H76.8008V153.602Z",
  fill: "#b76401"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M307.199 512H170.668C165.957 512 162.133 508.176 162.133 503.465V418.133C162.133 413.422 165.957 409.602 170.668 409.602H307.199C311.91 409.602 315.734 413.422 315.734 418.133V503.465C315.734 508.176 311.91 512 307.199 512V512ZM179.199 494.934H298.668V426.668H179.199V494.934Z",
  fill: "#b76401"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M503.465 512H8.53516C3.82422 512 0 508.176 0 503.465C0 498.758 3.82422 494.934 8.53516 494.934H503.465C508.176 494.934 512 498.758 512 503.465C512 508.176 508.176 512 503.465 512V512Z",
  fill: "#b76401"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M136.535 119.465H85.332C80.6211 119.465 76.8008 115.645 76.8008 110.934V85.332C76.8008 66.5078 92.1094 51.1992 110.934 51.1992C129.758 51.1992 145.066 66.5078 145.066 85.332V110.934C145.066 115.645 141.242 119.465 136.535 119.465ZM93.8672 102.398H128V85.332C128 75.9219 120.344 68.2656 110.934 68.2656C101.52 68.2656 93.8672 75.9219 93.8672 85.332V102.398Z",
  fill: "#b76401"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M110.934 68.2656C106.223 68.2656 102.398 64.4453 102.398 59.7344V8.53516C102.398 3.82422 106.223 0 110.934 0C115.645 0 119.465 3.82422 119.465 8.53516V59.7344C119.465 64.4453 115.645 68.2656 110.934 68.2656Z",
  fill: "#b76401"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M264.535 85.332H196.266C177.441 85.332 162.133 70.0234 162.133 51.1992C162.133 32.375 177.441 17.0664 196.266 17.0664C197.777 17.0664 199.277 17.168 200.773 17.375C206.719 6.84375 217.957 0 230.398 0C242.84 0 254.078 6.84375 260.027 17.375C261.52 17.168 263.023 17.0664 264.535 17.0664C283.359 17.0664 298.668 32.375 298.668 51.1992C298.668 70.0234 283.359 85.332 264.535 85.332ZM196.266 34.1328C186.855 34.1328 179.199 41.7891 179.199 51.1992C179.199 60.6133 186.855 68.2656 196.266 68.2656H264.535C273.945 68.2656 281.602 60.6133 281.602 51.1992C281.602 39.6641 269.508 30.8242 258.191 35.3945C255.934 36.3008 253.391 36.1992 251.203 35.1133C249.02 34.0313 247.406 32.0586 246.777 29.7031C244.762 22.2617 238.027 17.0664 230.398 17.0664C222.77 17.0664 216.039 22.2617 214.023 29.7031C213.383 32.0586 211.773 34.0234 209.598 35.1133C207.418 36.207 204.875 36.3008 202.605 35.3945C200.523 34.5586 198.391 34.1328 196.266 34.1328V34.1328Z",
  fill: "#b76401"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M85.332 230.398C80.6211 230.398 76.8008 226.578 76.8008 221.867V204.801C76.8008 200.09 80.6211 196.266 85.332 196.266C90.043 196.266 93.8672 200.09 93.8672 204.801V221.867C93.8672 226.578 90.043 230.398 85.332 230.398Z",
  fill: "#b76401"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M136.535 230.398C131.824 230.398 128 226.578 128 221.867V204.801C128 200.09 131.824 196.266 136.535 196.266C141.242 196.266 145.066 200.09 145.066 204.801V221.867C145.066 226.578 141.242 230.398 136.535 230.398Z",
  fill: "#b76401"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M110.934 264.535C106.223 264.535 102.398 260.711 102.398 256V238.934C102.398 234.223 106.223 230.398 110.934 230.398C115.645 230.398 119.465 234.223 119.465 238.934V256C119.465 260.711 115.645 264.535 110.934 264.535Z",
  fill: "#b76401"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M85.332 298.668C80.6211 298.668 76.8008 294.844 76.8008 290.133V273.066C76.8008 268.355 80.6211 264.535 85.332 264.535C90.043 264.535 93.8672 268.355 93.8672 273.066V290.133C93.8672 294.844 90.043 298.668 85.332 298.668V298.668Z",
  fill: "#b76401"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M136.535 298.668C131.824 298.668 128 294.844 128 290.133V273.066C128 268.355 131.824 264.535 136.535 264.535C141.242 264.535 145.066 268.355 145.066 273.066V290.133C145.066 294.844 141.242 298.668 136.535 298.668V298.668Z",
  fill: "#b76401"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M110.934 332.801C106.223 332.801 102.398 328.977 102.398 324.266V307.199C102.398 302.488 106.223 298.668 110.934 298.668C115.645 298.668 119.465 302.488 119.465 307.199V324.266C119.465 328.977 115.645 332.801 110.934 332.801V332.801Z",
  fill: "#b76401"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M85.332 366.934C80.6211 366.934 76.8008 363.109 76.8008 358.398V341.332C76.8008 336.621 80.6211 332.801 85.332 332.801C90.043 332.801 93.8672 336.621 93.8672 341.332V358.398C93.8672 363.109 90.043 366.934 85.332 366.934V366.934Z",
  fill: "#b76401"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M136.535 366.934C131.824 366.934 128 363.109 128 358.398V341.332C128 336.621 131.824 332.801 136.535 332.801C141.242 332.801 145.066 336.621 145.066 341.332V358.398C145.066 363.109 141.242 366.934 136.535 366.934V366.934Z",
  fill: "#b76401"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M110.934 401.066C106.223 401.066 102.398 397.242 102.398 392.535V375.465C102.398 370.758 106.223 366.934 110.934 366.934C115.645 366.934 119.465 370.758 119.465 375.465V392.535C119.465 397.242 115.645 401.066 110.934 401.066Z",
  fill: "#b76401"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M85.332 435.199C80.6211 435.199 76.8008 431.379 76.8008 426.668V409.602C76.8008 404.891 80.6211 401.066 85.332 401.066C90.043 401.066 93.8672 404.891 93.8672 409.602V426.668C93.8672 431.379 90.043 435.199 85.332 435.199V435.199Z",
  fill: "#b76401"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M136.535 435.199C131.824 435.199 128 431.379 128 426.668V409.602C128 404.891 131.824 401.066 136.535 401.066C141.242 401.066 145.066 404.891 145.066 409.602V426.668C145.066 431.379 141.242 435.199 136.535 435.199V435.199Z",
  fill: "#b76401"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M110.934 469.332C106.223 469.332 102.398 465.512 102.398 460.801V443.734C102.398 439.023 106.223 435.199 110.934 435.199C115.645 435.199 119.465 439.023 119.465 443.734V460.801C119.465 465.512 115.645 469.332 110.934 469.332V469.332Z",
  fill: "#b76401"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M221.867 469.332H204.801C200.09 469.332 196.266 465.512 196.266 460.801C196.266 456.09 200.09 452.266 204.801 452.266H221.867C226.578 452.266 230.398 456.09 230.398 460.801C230.398 465.512 226.578 469.332 221.867 469.332V469.332Z",
  fill: "#b76401"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M273.066 469.332H256C251.289 469.332 247.465 465.512 247.465 460.801C247.465 456.09 251.289 452.266 256 452.266H273.066C277.777 452.266 281.602 456.09 281.602 460.801C281.602 465.512 277.777 469.332 273.066 469.332V469.332Z",
  fill: "#b76401"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M341.332 477.867C336.621 477.867 332.801 474.043 332.801 469.332V179.199C332.801 174.488 336.621 170.668 341.332 170.668C346.043 170.668 349.867 174.488 349.867 179.199V469.332C349.867 474.043 346.043 477.867 341.332 477.867Z",
  fill: "#b76401"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M341.332 153.602C336.621 153.602 332.801 149.777 332.801 145.066V128C332.801 123.289 336.621 119.465 341.332 119.465C346.043 119.465 349.867 123.289 349.867 128V145.066C349.867 149.777 346.043 153.602 341.332 153.602Z",
  fill: "#b76401"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M375.465 426.668C370.758 426.668 366.934 422.844 366.934 418.133V128C366.934 123.289 370.758 119.465 375.465 119.465C380.176 119.465 384 123.289 384 128V418.133C384 422.844 380.176 426.668 375.465 426.668V426.668Z",
  fill: "#b76401"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M375.465 477.867C370.758 477.867 366.934 474.043 366.934 469.332V452.266C366.934 447.555 370.758 443.734 375.465 443.734C380.176 443.734 384 447.555 384 452.266V469.332C384 474.043 380.176 477.867 375.465 477.867V477.867Z",
  fill: "#b76401"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M273.066 392.535C268.355 392.535 264.535 388.711 264.535 384V256C264.535 251.289 268.355 247.465 273.066 247.465C277.777 247.465 281.602 251.289 281.602 256V384C281.602 388.711 277.777 392.535 273.066 392.535V392.535Z",
  fill: "#b76401"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M238.934 426.668H170.668C165.957 426.668 162.133 422.844 162.133 418.133V281.602C162.133 276.891 165.957 273.066 170.668 273.066H238.934C243.645 273.066 247.465 276.891 247.465 281.602V418.133C247.465 422.844 243.645 426.668 238.934 426.668V426.668ZM179.199 409.602H230.398V290.133H179.199V409.602Z",
  fill: "#b76401"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M204.801 384C200.09 384 196.266 380.176 196.266 375.465V324.266C196.266 319.555 200.09 315.734 204.801 315.734C209.512 315.734 213.332 319.555 213.332 324.266V375.465C213.332 380.176 209.512 384 204.801 384Z",
  fill: "#b76401"
});

function SvgCivil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCivil);
export default __webpack_public_path__ + "static/media/civil.910c819f.svg";
export { ForwardRef as ReactComponent };